import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import BasicButton from '../button/BasicButton';

const ActionDialog = ({
  open,
  onClose,
  onConfirm,
  title,
  children,
  confirmText = '확인',
  cancelText = '취소',
  showCancel = true,
  TransitionProps,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      TransitionProps={TransitionProps}
      sx={{
        '& .MuiDialog-paper': {
          mx: 2.5,
          px: 0,
          pt: '40px',
          pb: '30px',
          width: { xs: '100%', md: 'auto' },
          minWidth: { md: 380 },
        },
      }}
    >
      {title && (
        <DialogTitle
          fontSize={{ xs: 18, md: 20 }}
          fontWeight={700}
          sx={{ px: 2.5, py: 0, mb: 1.5 }}
        >
          {title}
        </DialogTitle>
      )}
      <DialogContent sx={{ p: 2.5, mb: 2.5 }}>{children}</DialogContent>
      <DialogActions sx={{ px: 2.5, py: 0, width: '100%' }}>
        {showCancel && (
          <BasicButton
            onClick={onClose}
            variant="outlined"
            sx={{
              flex: 1,
              padding: '16px 20px',
              minWidth: { md: '166px' },
            }}
          >
            {cancelText}
          </BasicButton>
        )}
        <BasicButton
          onClick={onConfirm}
          sx={{
            flex: 1,
            padding: '16px 20px',
            minWidth: { md: '166px' },
          }}
        >
          {confirmText}
        </BasicButton>
      </DialogActions>
    </Dialog>
  );
};

export default ActionDialog;
